import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatableItemSummary, DeliveryMethod, ItemType } from '@vendasta/marketplace-apps';

@Pipe({
  name: 'formatProductType',
  standalone: false,
})
export class FormatProductTypePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(item: ActivatableItemSummary): string {
    if (item.itemType === ItemType.ITEM_TYPE_PACKAGE) {
      return this.translateService.instant('INVENTORY_UI.COMMON.ITEM_TYPE.PACKAGE');
    }

    switch (item.deliveryMethod) {
      case DeliveryMethod.DELIVERY_METHOD_PRODUCT:
        switch (item.itemType) {
          case ItemType.ITEM_TYPE_APP:
          case ItemType.ITEM_TYPE_ADDON:
            return this.translateService.instant('INVENTORY_UI.COMMON.ITEM_TYPE.PRODUCT');
          default:
            return '';
        }
      case DeliveryMethod.DELIVERY_METHOD_SERVICE:
        return this.translateService.instant('INVENTORY_UI.COMMON.ITEM_TYPE.SERVICE');
      default:
        return '';
    }
  }
}
